// extracted by mini-css-extract-plugin
export default {"counterModel":"CounterModel_counterModel__gO0au"};